import * as React from "react";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import axiosService, { baseUrl } from "./axios";
import { CircularProgress, Link, Grid } from "@mui/material";
import { Select, MenuItem, FormControl, InputLabel } from "@mui/material";
import { ArrowForward } from "@mui/icons-material";
import * as Yup from "yup";

export default function Home({ setUser }: any) {
  const [step, setStep] = React.useState(0);
  const [isError, setIsError] = React.useState(false);
  const [isUploading, setIsUploading] = React.useState(false);
  const [mwLists, setMwLists] = React.useState<any>([]);
  const [selectedMwListId, setSelectedMwListId] = React.useState<any>("");
  const [timestamp, setTimestamp] = React.useState<any>("");
  React.useEffect(() => {
    axiosService
      .get("mw-lists")
      .then(({ data }) => {
        const lists = data.records.map((item: any) => ({
          id: item.general?.list_uid,
          name: item.general?.name,
        }));
        setMwLists(lists);
      })
      .catch((err) => {
        setUser(null);
        setIsError(true);
      });
  }, []);

  const email = localStorage.getItem("email");
  const handleFileValidation = async (e: React.ChangeEvent) => {
    const target = e.target as HTMLInputElement;
    const files = target.files as FileList;
    const file = files[0];
    // read a chunk of the file
    if (file) {
      const blob = file.slice(0, 30000);
      const reader = new FileReader();
      reader.readAsText(blob);
      reader.onload = async (e) => {
        const text = e.target?.result as string;
        const lines = text.split(/\r\n|\n/);
        lines.pop();

        for (let i = 0; i < lines.length; i++) {
          const line = lines[i];
          const fields = line.split(",");
          console.log(fields);
          if (fields.length !== 3) {
            alert("Invalid file format");
            return;
          } else {
            const email = fields[0];
            const isValid = Yup.string().email().isValidSync(email);
            if (!isValid) {
              alert("Invalid emails in the file");
              return;
            }
          }
        }
        handleFileInput(file);
      };
    }
  };
  const handleFileInput = async (file: File) => {
    console.log("file input");
    setIsUploading(true);

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = async () => {
      const result = reader.result as string;
      const timestamp = Date.now();
      setTimestamp(timestamp);
      axiosService
        .post("/upload", { data: result, timestamp })
        .then((res) => {
          setIsUploading(false);
          setStep(1);
        })
        .catch((e) => {
          setIsError(true);
          setIsUploading(false);
        });
    };
  };
  const handleSend = () => {
    if (!selectedMwListId) {
      alert("Please select a Mailwizz list");
      return;
    }
    setIsUploading(true);
    axiosService
      .post("/send-to-mw/" + selectedMwListId, {
        listId: selectedMwListId,
        timestamp,
      })
      .then((res) => {
        setIsUploading(false);
        alert("Emails sent successfully");
        setStep(0);
      })
      .catch(() => {
        setIsUploading(false);
        setIsError(true);
      });
  };
  return (
    <Card>
      <CardMedia
        component="img"
        height="150"
        image="data:image/jpeg;base64,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"
        alt="internal-platform"
      />
      <CardContent>
        <Typography gutterBottom variant="h5" component="div"></Typography>
        <Typography variant="body2" color="text.secondary">
          {step === 0
            ? `Upload the CSV file to our server here, The CSV file needs to be comma delimited with 1 record per row in the format "email","firstname","lastname," without a header row, this file will be transmitted
          to us and you will be given two files back - one with the
          valid emails and the other with the invalid emails.`
            : step === 1
            ? ` 
          Select the Mailwizz list you want to send the valid emails to.
          `
            : null}
        </Typography>

        {/* add a select  */}
        {step === 1 && (
          <>
            <Grid container spacing={2}>
              <Grid item>
                <Link
                  component={Button}
                  href={`${baseUrl}/static/valid-${email}-${timestamp}.csv`}
                  download="valid.csv"
                >
                  Download Valid Emails File
                </Link>
              </Grid>
              <Grid item>
                <Link
                  component={Button}
                  href={`${baseUrl}/static/invalid-${email}-${timestamp}.csv`}
                  download="invalid.csv"
                >
                  Download Invalid Emails File
                </Link>
              </Grid>
            </Grid>

            <FormControl fullWidth sx={{ mt: 2 }}>
              <InputLabel id="demo-simple-select-label">
                Mailwizz List
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={selectedMwListId}
                onChange={(e) => setSelectedMwListId(e.target.value)}
                label="Age"
              >
                {mwLists.map((item: any) => (
                  <MenuItem key={item.id} value={item.id}>
                    {item.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </>
        )}
      </CardContent>
      <CardActions
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        {isError ? (
          <Typography color="error">Error uploading file</Typography>
        ) : null}
        {step === 0 ? (
          <Button
            disabled={isUploading || isError}
            component="label"
            size="large"
            variant="contained"
          >
            {isUploading ? (
              <CircularProgress />
            ) : (
              <>
                {" "}
                Upload{" "}
                <input
                  type="file"
                  accept=".csv"
                  hidden
                  onChange={handleFileValidation}
                />
              </>
            )}
          </Button>
        ) : (
          <Button
            endIcon={<ArrowForward />}
            component="label"
            size="large"
            disabled={isUploading || isError}
            variant="contained"
            color="info"
            onClick={handleSend}
          >
            {isUploading ? <CircularProgress /> : "Send"}
          </Button>
        )}
      </CardActions>
    </Card>
  );
}
